import React, {useEffect, useState} from "react";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js';
function Shift() {
    const [shiftName, setShiftName] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [viewShift, setViewShift] = useState([]);
    const [registerData, setRegisterData] = useState({
        monday_in_time: '',
        monday_out_time: '',
        tuesday_in_time: '',
        tuesday_out_time: '',
        wednesday_in_time: '',
        wednesday_out_time: '',
        thursday_in_time: '',
        thursday_out_time: '',
        friday_in_time: '',
        friday_out_time: '',
        saturday_in_time: '',
        saturday_out_time: '',
        sunday_in_time: '',
        sunday_out_time: ''
    });
    const handleChange = (day, field, value) => {
        setRegisterData(prevData => ({
            ...prevData,
            [`${day}_${field}`]: value
        }));
    };
    useEffect(() => {
        console.log(registerData);
    }, [registerData]);
    const submitHandler = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('shift_name', shiftName);
        formData.append('monday_in_time', registerData.monday_in_time);
        formData.append('monday_out_time', registerData.monday_out_time);
        formData.append('tuesday_in_time', registerData.tuesday_in_time);
        formData.append('tuesday_out_time', registerData.tuesday_out_time);
        formData.append('wednesday_in_time', registerData.wednesday_in_time);
        formData.append('wednesday_out_time', registerData.wednesday_out_time);
        formData.append('thursday_in_time', registerData.thursday_in_time);
        formData.append('thursday_out_time', registerData.thursday_out_time);
        formData.append('friday_in_time', registerData.friday_in_time);
        formData.append('friday_out_time', registerData.friday_out_time);
        formData.append('saturday_in_time', registerData.saturday_in_time);
        formData.append('saturday_out_time', registerData.saturday_out_time);
        formData.append('sunday_in_time', registerData.sunday_in_time);
        formData.append('sunday_out_time', registerData.sunday_out_time);
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
        formData.append('location', userLocation);
        axios.post(baseUrl + 'create-shift/', formData)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    Swal.fire({
                        title: 'Shift List Created successfully',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setTimeout(() => {
                        window.location.href = '/add-shift';
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to Create. Please try again later.',
                    'error'
                );
            });
    };
    useEffect(() => {
        fetchData();
    }, []);
    useEffect(() => {
        if (viewShift.length > 0) {
            setRows(viewShift);
        }
    }, [viewShift]);
    function fetchData() {
        setIsLoading(true);
        axios.get(`${baseUrl}create-shift/`)
            .then(response => {
                setViewShift(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you sure you want to delete this?',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-shift/' + id + '/')
                        .then(function (response) {
                            Swal.fire('Success', 'Data has been deleted');
                            window.location.reload();
                        });
                } catch (error) {
                    Swal.fire('Error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('Error', 'Data has not been deleted');
            }
        });
    };
    const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    const columns = [
        {field: 'id', headerName: 'ID', width: 50},
        {field: 'shift_name', headerName: 'Shift', width: 150},
        ...daysOfWeek.flatMap(day => [
            {field: `${day}_in_time`, headerName: `${day.charAt(0).toUpperCase() + day.slice(1)} In`, width: 100},
            {field: `${day}_out_time`, headerName: `${day.charAt(0).toUpperCase() + day.slice(1)} Out`, width: 100}
        ]),
        {
            field: 'edit', headerName: 'Edit', width: 80,
            renderCell: (params) => (
                <Link to={`/shift-view/${params.row.id}/`} target="_blank" className="btn btn-warning">
                    Edit
                </Link>
            )
        },
        {
            field: 'delete', headerName: 'Action', width: 80,
            renderCell: (params) => (
                <button onClick={() => handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
                    <i className="fa-solid fa-trash-can"></i>
                </button>
            )
        },
    ];
    return (
        <section className="container mt-4">

            <div className="card shadow-sm border-0">

                <h4
                    className="card-header text-center py-3"
                    style={{
                        color: "black",
                        backgroundColor: "#e5eaef",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                        fontWeight: "600",
                    }}
                >
                    <i
                        className="fa-solid fa-clock"
                        aria-hidden="true"
                        style={{color: "red"}}
                    ></i>
                    Shift List
                </h4>

                <div className="card-body p-4">

                    <form>

                        {/* Shift Name */}
                        <div className="row align-items-center mb-4">

                            <div className="col-md-3">
                                <label
                                    htmlFor="shiftName"
                                    className="form-label fw-semibold mb-0"
                                >
                                    Shift Name
                                </label>
                            </div>

                            <div className="col-md-5">
                                <input
                                    type="text"
                                    id="shiftName"
                                    name="shiftName"
                                    value={shiftName}
                                    onChange={(e) => setShiftName(e.target.value)}
                                    className="form-control"
                                    placeholder="Enter Shift Name"
                                />
                            </div>

                        </div>

                        {/* Shift Timings */}
                        <div className="row">

                            <div className="col-12">

                                {daysOfWeek.map((day) => (
                                    <div
                                        key={day}
                                        className="row align-items-center mb-4"
                                    >

                                        <div className="col-md-3">
                                            <label
                                                htmlFor={day}
                                                className="form-label fw-semibold mb-0"
                                            >
                                                {day.charAt(0).toUpperCase() + day.slice(1)}
                                            </label>
                                        </div>

                                        <div className="col-md-4 mb-2 mb-md-0">
                                            <TextField
                                                fullWidth
                                                type="time"
                                                label="In Time"
                                                value={registerData[`${day}_in_time`]}
                                                onChange={(e) =>
                                                    handleChange(day, "in_time", e.target.value)
                                                }
                                                InputLabelProps={{shrink: true}}
                                                inputProps={{step: 300}}
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <TextField
                                                fullWidth
                                                type="time"
                                                label="Out Time"
                                                value={registerData[`${day}_out_time`]}
                                                onChange={(e) =>
                                                    handleChange(day, "out_time", e.target.value)
                                                }
                                                InputLabelProps={{shrink: true}}
                                                inputProps={{step: 300}}
                                            />
                                        </div>

                                    </div>
                                ))}

                            </div>

                        </div>

                        {/* Submit Button */}
                        <div className="row mt-4">

                            <div className="col-md-12 text-center">

                                <button
                                    type="button"
                                    onClick={submitHandler}
                                    className="btn btn-success px-5 py-2"
                                >
                                    Submit
                                </button>

                            </div>

                        </div>

                    </form>

                </div>

            </div>

            {/* Grid */}

            <div style={{height: "100%", width: "100%"}}>

                <DataGrid
                    className="mt-4"
                    sx={{
                        boxShadow: 4,
                        border: 4,
                        borderColor: "primary.light",
                        "& .MuiDataGrid-cell:hover": {
                            color: "primary.main",
                        },
                    }}
                    pageSize={28}
                    rows={rows}
                    columns={columns}
                    components={{
                        Toolbar: GridToolbar,
                    }}
                />

            </div>

        </section>
    );
}
export default Shift;
